if (!window.paymentTermsFont && 'adoptedStyleSheets' in Document.prototype) {
  window.paymentTermsFont = true;
  const sheet = new CSSStyleSheet();
  sheet.replaceSync('.font-sans, :host { font-family: inherit; } .font-bold, b, strong { font-weight: 500; }');
  const apply = () => {
    document.querySelectorAll('shopify-payment-terms').forEach((host) => {
      const root = host.shadowRoot;
      if (root && !root.adoptedStyleSheets.includes(sheet)) root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    });
  };
  const start = () => {
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
    let tries = 0;
    const timer = setInterval(() => {
      apply();
      if (++tries > 20) clearInterval(timer);
    }, 500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}
